<template>
    <div v-if="users.length" class="category_members">
        <div class="container">
            <div class="category_title second_font text_center">
                {{ group.name }}
            </div>

            <div class="columns_wrapper flex item_center">
                <single-person
                    v-for="(person, index) of users"
                    :key="person.fullName + index"
                    :person="person"
                    @contact-us="onContactUs"
                />
            </div>

            <div v-if="total > users.length" class="btn_wrapper text_center">
                <a class="btn btn_green" @click="fetchGroup(true)">
                    הצג עוד
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import BaseGroup from '@/components/about/BaseGroup';
import SinglePerson from '@/components/about/SinglePerson';

export default {
    components: {
        SinglePerson
    },

    extends: BaseGroup
};
</script>
